import React from "react";
import { MoonIcon, SunIcon } from "lucide-react";
import { useTheme } from "../hooks/useTheme";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import { ThemeToggle } from "../../../components/ThemeToggle";

interface AuthLayoutProps {
  children: React.ReactNode;
  className?: string;
}

export const AuthLayout: React.FC<AuthLayoutProps> = ({
  children,
  className,
}) => {
  const { theme, setTheme } = useTheme();

  const toggleTheme = () => {
    setTheme(theme === "dark" ? "light" : "dark");
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-4 bg-background">
      <div className={cn("w-full max-w-md mx-auto", className)}>
        <div className="flex flex-col items-center mb-8">
          <img
            src="https://cdn.wealthbee.io/enterprise/daappa_logo.svg"
            alt="Daappa Logo"
            className="h-26 w-12"
          />
          <h1 className="text-2xl font-bold ml-2 text-foreground">daappa</h1>
          <p className="text-sm text-muted-foreground">Enterprise Portal</p>
        </div>

        {children}

        <div className="mt-8 flex justify-center gap-2">
          <Button
            variant="ghost"
            size="sm"
            className="flex items-center gap-2"
            onClick={toggleTheme}
          >
            {theme === "dark" ? (
              <>
                <SunIcon className="h-4 w-4" />
                <span className="text-xs">Switch to Light Mode</span>
              </>
            ) : (
              <>
                <MoonIcon className="h-4 w-4" />
                <span className="text-xs">Switch to Dark Mode</span>
              </>
            )}
          </Button>
          <ThemeToggle />
        </div>
      </div>
    </div>
  );
};
